import React from "react";
import { connect } from "react-redux";
import {
  Card,
  Col,
  Row,
} from "react-bootstrap";
import Swal from "sweetalert2";
import { useSelector, useDispatch } from 'react-redux';
import withReactContent from "sweetalert2-react-content";
import ReactPaginate from 'react-paginate';
import { updateSettings, deleteSettingsItem } from "../../actions/settings";
import BrandingItem from '../../components/settings/BrandingItem';
import CreateBrandingForm from '../../components/settings/CreateBrandingForm';
import BrandingPreivewForm from '../../components/settings/BrandingPreivewForm';
import "./Branding.scss";

const ReactSwal = withReactContent(Swal);
const ITEMS_PER_PAGE = 5;

const Branding = props => {
  const [pageCount, setPageCount] = React.useState(0);
  const [currentPage, setCurrentPage] = React.useState(0);
  const userInfo = useSelector(({ settings }) => settings.userInfo);
  const brandingOptions = useSelector(({ settings }) => settings.brandingOptions)
  const brandingList = useSelector(({ settings }) => {
    if (!settings.brandingOptions) {
      return []
    }

    return Object.keys(settings.brandingOptions)
      .map(key => ({
        ...settings.brandingOptions[key],
        name: key
      }))
      .filter(branding => !branding.deletedAt)
  });

  const dispatch = useDispatch();

  React.useEffect(() => {
    const newPageCount = Math.ceil(brandingList.length / ITEMS_PER_PAGE);
    setPageCount(newPageCount);

    if (currentPage >= newPageCount && newPageCount !== 0) {
      setCurrentPage(newPageCount - 1);
    }
  }, [brandingList, currentPage]);

  const onClickAddBranding = () => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <CreateBrandingForm
          onClose={ReactSwal.clickCancel}
          onSubmit={onCreateBrandingItem}
          user={props.user}
        />
      )
    })
    .then(result => {
      if (result.value) {
      }
    });
  };

  const onCreateBrandingItem = (data) => {
    const brandingData = {
      ...(brandingOptions || {}),
      [data.name]: {
        color: data.color,
        default: data.isDefault,
        sort: 10,
        logo: data.logo,
        favicon: data.favicon,
        siteImage: data.siteImage
      }
    }

    if (data.isDefault) {
      Object.keys(brandingData).forEach(brandName => {
        if (brandName !== data.name) {
          if (brandingData[brandName]) {
            brandingData[brandName].default = false
          }
        }
      })
    }

    dispatch(updateSettings(props.settings.id, 'brandingOptions', brandingData));
  }

  const onEditBrandingItem = (data, oldData) => {
    const brandingData = {
      ...(brandingOptions || {}),
    }

    if (oldData.name !== data.name) {
      delete brandingData[oldData.name]
    }

    brandingData[data.name] = {
      color: data.color,
      default: data.isDefault,
      sort: 10,
      logo: data.logo || oldData.logo,
      favicon: data.favicon || oldData.favicon,
      siteImage: data.siteImage || oldData.siteImage
    }

    if (data.isDefault) {
      Object.keys(brandingData).forEach(brandName => {
        if (brandName !== data.name) {
          if (brandingData[brandName]) {
            brandingData[brandName].default = false
          }
        }
      })
    }

    dispatch(updateSettings(props.settings.id, 'brandingOptions', brandingData));
  }

  const handlePageClick = data => {
    setCurrentPage(data.selected);
  };

  const onDeleteBrandingItem = (name) => {
    dispatch(deleteSettingsItem({
      listName: 'brandingOptions',
      itemName: name
    }))
  };
  
  const onPreviewBrandingItem = (name) => {
    const selBranding = brandingList.find(brand => brand.name === name);

    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <BrandingPreivewForm
          onClose={ReactSwal.clickCancel}
          data={selBranding}
        />
      )
    })
    .then(result => {
      if (result.value) {
      }
    });
  }

  const onClickEditBranding = (name) => {
    const selBranding = brandingList.find(brand => brand.name === name);

    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <CreateBrandingForm
          onClose={ReactSwal.clickCancel}
          item={selBranding}
          onSubmit={data => onEditBrandingItem(data, selBranding)}
          isEditing
          user={props.user}
        />
      )
    })
    .then(result => {
      if (result.value) {
      }
    });
  };

  const filteredBrandingList = brandingList.filter((key, idx) => {
      if (currentPage * ITEMS_PER_PAGE <= idx && (currentPage + 1) * ITEMS_PER_PAGE > idx) {
        return true;
      }

      return false;
    })

  return (
    <div className="branding-container position-relative">
      <Row className="full-width">
        <Col>
          <Row className="full-width">
            <Card bg="light" className="full-width full-height">
              <Card.Header>About Branding</Card.Header>
              <Card.Body>
                The branding configured here allows configuration of the color, images, and logos used when sharing individual assets and sites. Use different branding for different products, regions, or organization units.
              </Card.Body>
            </Card>
          </Row>

          <Row className="full-width">
            <Card bg="light" className="full-width full-height">
              <Card.Header>Brands</Card.Header>
              <Card.Body>
                <div className="add-branding-button" onClick={onClickAddBranding}>
                  +
                </div>
                <div className="branding-items-list">
                  {
                    filteredBrandingList
                      .map((branding) => (
                          <BrandingItem
                            key={branding.name}
                            avatar={branding.imageUrl}
                            userInfo={userInfo}
                            data={branding}
                            onPreview={() => onPreviewBrandingItem(branding.name)}
                            onDelete={() => onDeleteBrandingItem(branding.name)}
                            onEdit={() => onClickEditBranding(branding.name)}
                          />
                        )
                      )
                  }
                </div>
                {brandingList.length > ITEMS_PER_PAGE && (
                  <div className="pagination-container">
                    <ReactPaginate
                      previousLabel={'<'}
                      nextLabel={'>'}
                      breakLabel={'...'}
                      breakClassName={'break-me'}
                      pageCount={pageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageClick}
                      containerClassName={'pagination'}
                      subContainerClassName={'pages pagination'}
                      activeClassName={'active'}
                      forcePage={currentPage}
                    />
                  </div>
                )}
              </Card.Body>
            </Card>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

const mapStateToProps = state => ({
  settings: state.settings,
  user: state.auth.tenant || {},
  Auth: state.auth.Auth,
  cognitoUser: state.auth.cognitoUser,
});

export default connect(mapStateToProps)(Branding);
